import { Grid } from '@mui/material';
import { GridColDef, DataGrid, GridToolbar } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { getSubmissionsByRecruiterJobsCRM } from 'wisestep-api';
import { WsTypography, WsColors } from 'wisestep-base';

import NoDataFoundCard from '../../../../components/noDataFoundCard';
import { IAggregation } from '../../types';

import IPayloadDTOJobsCrm from './types/IPayloadDTOJobsCrm';

const SubmissionsByRecruiter = ({ payload }: IPayloadDTOJobsCrm) => {
  const [aggregatedData, setAggregatedData] = useState<IAggregation[]>();

  const tableData: Record<string, unknown>[] = [];

  const paginationSize = 10;
  let submissionsCount = 0;

  useEffect(() => {
    const fetchData = async () => {
      const response = await getSubmissionsByRecruiterJobsCRM(payload);
      setAggregatedData(response.data.aggregations.aggregation.buckets);
    };
    fetchData();
  }, [payload]);

  aggregatedData?.map((item) => {
    tableData.push({
      id: item.key,
      submissions: item.doc_count,
    });
    submissionsCount += item.doc_count;
  });

  const columns: GridColDef[] = [
    { field: 'id', headerName: `Recruiters`, flex: 2 },
    {
      field: 'submissions',
      headerName: `Submissions (${submissionsCount})`,
      flex: 1,
    },
  ];
  return (
    <Grid container justifyItems={'space-evenly'} spacing={2} textAlign="center">
      <Grid item xs={12}>
        <WsTypography>Submissions by Recruiters</WsTypography>
        {tableData ? (
          <div style={{ height: 350, background: WsColors.White }}>
            <DataGrid
              columns={columns}
              rows={tableData}
              components={{ Toolbar: GridToolbar }}
              pageSize={paginationSize}
              rowsPerPageOptions={[paginationSize]}
            />
          </div>
        ) : (
          <NoDataFoundCard text="No Records Found" />
        )}
      </Grid>
    </Grid>
  );
};
export default SubmissionsByRecruiter;
